import React from 'react';
import { TwinFnOrder, TWinfnRank } from '../../../types/types';
import { radioButton } from '../../ChartAxes/CardComponents/ReusableStyles/CommonStyles';
import { Radio, Typography } from '@mui/material';
interface StandingProps {
  rank: TWinfnRank;
  order: TwinFnOrder;
  onChange: (
    optionType: 'standing' | 'sliding' | 'standingsvssliding',
    idx: number,
    value: string | number,
    type: string,
  ) => void;
}
function Standing({ rank, order, onChange }: StandingProps) {
  const ranks: TWinfnRank[] = ['default', 'dense', 'unique'];
  const orders: TwinFnOrder[] = ['ascending', 'descending'];
  return (
    <div className="MenuSize" onDoubleClick={(e) => e.stopPropagation()}>
      <div className="standingMain">
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 'bold',
            color: 'primary.main',
            paddingLeft: '15px',
          }}
        >
          Rank
        </Typography>
        {ranks.map((option, index) => (
          <div className="commonOption1" key={index} style={{ marginBottom: '0px' }}>
            <Radio
              size="small"
              checked={rank === option}
              value={option}
              sx={{
                ...radioButton,
                marginTop: '0',
                paddingTop: '0',
                paddingLeft: '15px',
              }}
              onClick={() => onChange('standing', 1, option, 'rank')}
            />
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                marginTop: '0',
                paddingBottom: '7px',
              }}
            >
              {option.charAt(0).toUpperCase() + option.slice(1).toLowerCase()}
            </Typography>
          </div>
        ))}
      </div>

      <div>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: '600',
            color: 'rgb(96, 96, 96)',
            paddingLeft: '15px',
            marginTop: '2px',
          }}
        >
          Order
        </Typography>
        {orders.map((option, index) => (
          <div className="commonOption1" key={index}>
            <Radio
              size="small"
              checked={order === option}
              value={option}
              sx={{
                ...radioButton,
                marginTop: '0',
                paddingTop: '0',
                paddingLeft: '15px',
              }}
              onClick={() => onChange('standing', 2, option, 'order')}
            />
            <Typography
              sx={{
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                marginTop: '0',
                paddingBottom: '7px',
              }}
            >
              {option.charAt(0).toUpperCase() + option.slice(1).toLowerCase()}
            </Typography>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Standing;
